import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { filters, headers } from "./config";

const RequestList = () => {

  return (
    <Table tableId="requests" title="Request" icon={InventoryRoundedIcon}  headers={headers} filters={filters} defaultSort="date_created" additionalCollections="v:full_name" />
  );
};

export default RequestList;